import { computed, defineComponent, ref } from 'vue';
import { useStore } from '@/plugins/vuex';
import EditRatesModal from './editRatesModal/EditRatesModal.vue';
import SPopUp from '@/components/stemdo-components/s-pop-up/SPopUp.vue';
import { useI18N } from '@/plugins/i18n';

export default defineComponent({
  components: { EditRatesModal, SPopUp },
  setup() {
    const store = useStore();
    const i18n = useI18N();
    const isManager = store.getters.account?.authorities.includes('ROLE_GESTOR') ?? false;
    function createSelectionChecker(getterKey: string) {
      return computed(() => {
        const selected = store.getters[`cartStore/${getterKey}`];
        if (isManager) {
          return selected !== null && selected !== undefined;
        }
        return true;
      });
    }

    const isCompanySelected = createSelectionChecker('companySelected');
    const showEditRatesModal = ref(false);

    const openEditRatesModal = () => {
      showEditRatesModal.value = true;
    };
    const closeEditRatesModal = () => {
      showEditRatesModal.value = false;
    };

    const popUpData = ref({
      message: '',
      isOpen: false,
      isValid: true
    });

    const showPopUp = (data: { message: string; isOpen: boolean; isValid: boolean }) => {
      // Usar traducción para el mensaje si es éxito o error
      if (data.message === 'Rates guardados correctamente.' || data.message === 'Rates saved successfully.') {
        data.message = i18n.t('sEditRates.popupSuccess').toString();
      }
      if (data.message === 'Error al actualizar los rates.' || data.message === 'Error updating rates.') {
        data.message = i18n.t('sEditRates.popupError').toString();
      }
      popUpData.value = data;
      if (data.isOpen) {
        setTimeout(() => {
          popUpData.value.isOpen = false;
        }, 2000);
      }
    };

    const closePopUp = () => {
      popUpData.value.isOpen = false;
    };

    return {
      isCompanySelected,
      showEditRatesModal,
      isManager,
      closeEditRatesModal,
      openEditRatesModal,
      popUpData,
      showPopUp,
      closePopUp
    };
  }
});
